import { createTracker } from 'usage-tracker';
import { THEME_PREVIEWER_NAMESPACE } from '../constants/usage/standaloneTracking';
export const usageTracker = createTracker({
  standalone: true
});
export const track = (event, properties) => {
  usageTracker.track(THEME_PREVIEWER_NAMESPACE, event, properties);
};